var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 10,
    fill: "#6F4200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.8573 -15.5184C94.8573 -15.5184 68.4787 -2.95593 73.1606 28.1212C78.4135 62.967 47.9525 77.9223 27.1408 69.308C6.32911 60.6639 7.78508 28.6895 -31.7828 27.7024C-72.2071 26.7154 -80.7145 -13.5443 -80.7145 -13.5443",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3677 -24.8806C64.3677 -24.8806 52.9484 1.68004 57.0308 28.0911C61.1418 54.5021 42.671 57.6128 35.3341 54.5021C20.0894 48.1013 17.1489 13.8237 -7.4597 11.6103C-25.959 9.93536 -50.8531 23.1857 -64.0424 -6.87439",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0634 -13.0358C52.0634 -13.0358 56.1743 14.0931 37.9891 9.24758C17.1489 3.68422 17.4629 -9.35679 -8.91565 2.96636C-18.308 7.36322 -56.1059 8.64937 -48.4835 -15.5184",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8741 45.1403C43.2415 45.1403 46.782 39.6766 46.782 32.9368C46.782 26.197 43.2415 20.7333 38.8741 20.7333C34.5067 20.7333 30.9663 26.197 30.9663 32.9368C30.9663 39.6766 34.5067 45.1403 38.8741 45.1403Z",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7437 45.6107C22.6284 45.6107 27.3989 40.8402 27.3989 34.9556C27.3989 29.0709 22.6284 24.3004 16.7437 24.3004C10.8591 24.3004 6.08862 29.0709 6.08862 34.9556C6.08862 40.8402 10.8591 45.6107 16.7437 45.6107Z",
    fill: "#FF9900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1038 32.6705C27.9885 32.6705 32.759 27.9 32.759 22.0153C32.759 16.1306 27.9885 11.3602 22.1038 11.3602C16.2192 11.3602 11.4487 16.1306 11.4487 22.0153C11.4487 27.9 16.2192 32.6705 22.1038 32.6705Z",
    fill: "#FF9900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0441 27.3104C40.9287 27.3104 45.6992 22.5399 45.6992 16.6552C45.6992 10.7706 40.9287 6.00012 35.0441 6.00012C29.1594 6.00012 24.3889 10.7706 24.3889 16.6552C24.3889 22.5399 29.1594 27.3104 35.0441 27.3104Z",
    fill: "#FF9900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9843 32.6705C53.869 32.6705 58.6394 27.9 58.6394 22.0153C58.6394 16.1306 53.869 11.3602 47.9843 11.3602C42.0996 11.3602 37.3292 16.1306 37.3292 22.0153C37.3292 27.9 42.0996 32.6705 47.9843 32.6705Z",
    fill: "#FF9900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3444 45.6107C59.229 45.6107 63.9995 40.8402 63.9995 34.9556C63.9995 29.0709 59.229 24.3004 53.3444 24.3004C47.4597 24.3004 42.6892 29.0709 42.6892 34.9556C42.6892 40.8402 47.4597 45.6107 53.3444 45.6107Z",
    fill: "#FF9900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9843 58.5512C53.869 58.5512 58.6394 53.7807 58.6394 47.8961C58.6394 42.0115 53.869 37.241 47.9843 37.241C42.0996 37.241 37.3292 42.0115 37.3292 47.8961C37.3292 53.7807 42.0996 58.5512 47.9843 58.5512Z",
    fill: "#FF9900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0441 63.9113C40.9287 63.9113 45.6992 59.1408 45.6992 53.2562C45.6992 47.3716 40.9287 42.6012 35.0441 42.6012C29.1594 42.6012 24.3889 47.3716 24.3889 53.2562C24.3889 59.1408 29.1594 63.9113 35.0441 63.9113Z",
    fill: "#FF9900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1038 58.5512C27.9885 58.5512 32.759 53.7807 32.759 47.8961C32.759 42.0115 27.9885 37.241 22.1038 37.241C16.2192 37.241 11.4487 42.0115 11.4487 47.8961C11.4487 53.7807 16.2192 58.5512 22.1038 58.5512Z",
    fill: "#FF9900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6246 16.6543C42.6246 12.4694 39.2295 9.07379 35.0441 9.07379C30.8587 9.07379 27.4635 12.4689 27.4635 16.6543C24.5029 13.6959 19.7031 13.6959 16.7425 16.6543C13.784 19.615 13.784 24.4147 16.7425 27.3754C12.5575 27.3754 9.16193 30.7705 9.16193 34.9559C9.16193 39.1409 12.5571 42.5365 16.7425 42.5365C13.784 45.4971 13.784 50.2969 16.7425 53.2574C19.7031 56.216 24.5029 56.216 27.4635 53.2574C27.4635 57.4425 30.8586 60.838 35.0441 60.838C39.2296 60.838 42.6246 57.4429 42.6246 53.2574C45.5853 56.216 50.3846 56.216 53.3456 53.2574C56.3042 50.2969 56.3042 45.4971 53.3456 42.5365C57.5306 42.5365 60.9236 39.1413 60.9236 34.9559C60.9236 30.771 57.5307 27.3754 53.3456 27.3754C56.3042 24.4147 56.3042 19.615 53.3456 16.6543C50.3846 13.6959 45.5853 13.6959 42.6246 16.6543Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9448 19.5571V27.951L43.8809 22.0149C43.8809 20.966 44.2813 19.9147 45.0819 19.1142C46.6855 17.5109 49.2843 17.5109 50.8853 19.1142C52.4886 20.7152 52.4886 23.3146 50.8853 24.9177C50.0848 25.7182 49.0335 26.1187 47.9846 26.1187L42.0485 32.0548H50.4424C51.1851 31.312 52.2105 30.8517 53.3451 30.8517C55.6104 30.8517 57.4468 32.6904 57.4468 34.9554C57.4468 37.2206 55.6103 39.0593 53.3452 39.0593C52.2105 39.0593 51.1851 38.5993 50.4424 37.8562H42.0485L47.9846 43.7923C49.0335 43.7923 50.0848 44.1928 50.8853 44.9933C52.4886 46.5969 52.4886 49.1957 50.8853 50.7968C49.2843 52.4004 46.6855 52.4004 45.0819 50.7968C44.2813 49.9962 43.8809 48.9449 43.8809 47.8961L37.9447 41.96V50.3538C38.6874 51.0964 39.1478 52.1219 39.1478 53.2566C39.1478 55.5217 37.3087 57.3583 35.044 57.3583C32.7789 57.3583 30.9402 55.5217 30.9402 53.2566C30.9402 52.1219 31.4002 51.0964 32.1433 50.3539V41.96L26.2072 47.8961C26.2072 48.9449 25.8067 49.9962 25.0062 50.7968C23.4026 52.4004 20.8038 52.4004 19.2027 50.7968C17.5991 49.1953 17.5991 46.5964 19.2027 44.9933C20.0033 44.1928 21.0546 43.7923 22.1034 43.7923L28.0395 37.8562H19.6457C18.903 38.5988 17.8776 39.0593 16.7429 39.0593C14.4778 39.0593 12.6412 37.2205 12.6412 34.9554C12.6412 32.6904 14.4778 30.8516 16.7429 30.8516C17.8776 30.8516 18.903 31.312 19.6457 32.0547H28.0395L22.1034 26.1187C21.0546 26.1187 20.0033 25.7186 19.2027 24.9177C17.5991 23.3141 17.5991 20.7152 19.2027 19.1142C20.8041 17.5109 23.4026 17.5109 25.0062 19.1142C25.8067 19.9147 26.2072 20.966 26.2072 22.0149L32.1433 27.951V19.5571C31.4006 18.8144 30.9402 17.789 30.9402 16.6544C30.9402 14.3892 32.779 12.5527 35.044 12.5527C37.3087 12.5527 39.1479 14.3892 39.1479 16.6543C39.1479 17.789 38.6874 18.8144 37.9448 19.5571Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.1644 34.9998H60.921V60.835H9.1644V34.9998Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.1644 49.4976H60.921V60.8355H9.1644V49.4976Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5891 37.3962H55.9185C57.6118 37.3962 58.9948 38.7792 58.9948 40.4725V50.8487C43.0229 48.8726 27.1876 46.1412 11.5129 46.3937V40.4726C11.5129 38.7793 12.8954 37.3964 14.5891 37.3964V37.3962Z",
    fill: "#3F3F3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7573 36.6981L36.9793 59.7758H33.0191L28.2386 36.6981H32.1991L34.999 50.2148L37.7972 36.6981H41.7573ZM48.5178 46.2569H55.2782V53.0153C55.2782 56.7488 52.2513 59.7758 48.5199 59.7758C44.7863 59.7758 41.7594 56.7488 41.7594 53.0153V43.4569H41.7573C41.7573 39.7255 44.7842 36.6986 48.5178 36.6986C52.2513 36.6986 55.2782 39.7255 55.2782 43.4569H51.3177C51.3177 41.9111 50.0632 40.6591 48.5178 40.6591C46.972 40.6591 45.72 41.9116 45.72 43.4569V53.0153C45.72 54.561 46.9724 55.8153 48.5178 55.8153C50.0632 55.8153 51.3177 54.5606 51.3177 53.0174V50.2174H48.5178V46.2569ZM16.7 48.2368C15.4778 47.0124 14.7197 45.3233 14.7197 43.4565C14.7197 39.723 17.7467 36.6981 21.4802 36.6981C25.2115 36.6981 28.2385 39.723 28.2385 43.4565H24.2801C24.2801 41.9111 23.0255 40.6566 21.4801 40.6566C19.9343 40.6566 18.6802 41.9111 18.6802 43.4565C18.6802 44.2294 18.9927 44.927 19.4982 45.4347H19.5003C19.7601 45.6951 20.0688 45.9015 20.4086 46.0422C20.7485 46.1828 21.1127 46.2549 21.4805 46.2543V46.2564C23.3473 46.2564 25.0364 47.0124 26.2587 48.2368C27.483 49.459 28.2389 51.1501 28.2389 53.0148C28.2389 56.7484 25.212 59.7753 21.4805 59.7753C17.747 59.7753 14.7201 56.7484 14.7201 53.0148H18.6802C18.6802 54.5628 19.9348 55.8148 21.4802 55.8148C23.0259 55.8148 24.2801 54.5623 24.2801 53.0148C24.2801 52.244 23.9676 51.5444 23.4604 51.0366C22.9533 50.5316 22.2531 50.2166 21.4802 50.2166C19.6134 50.217 17.9244 49.4591 16.7 48.2368Z",
    fill: "white",
    stroke: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: -9,
    y: -5,
    width: 88,
    height: 88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 10,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg);
export default __webpack_public_path__ + "static/media/svg.5c67b36f74ca19494787f8b2eb85df6d.svg";
export { ForwardRef as ReactComponent };